<template>
  <div class="store-Header">
    <div class="main">
      <!-- 店铺logo -->
      <div class="main-bg">
        <img :src="logoTop" alt="" v-if="logoTop"/>
        <img src="../../../assets/images/zfStoreBg.png" alt="" v-else/>
        <!-- <div class="main-logo">
          <img src="../../../assets/images/main/logo.png" alt="" />
        </div> -->
        <div class="main-fullname">
          <span class="main-span">{{ shopName }}</span>
          <!-- <span style="font-size: 16px; letter-spacing: 15px"
            >极配正品·不卖假件</span
          > -->
        </div>
      </div>
      <!-- 店铺搜索 -->
      <div class="main-search">
        <!-- 这期暂时以藏？？ -->
        <ul
        >
          <li :class="{ active: this.activeName === 'homePage' }">
            <router-link
              rel="opener"
              :to="{
                path: '/homePage',
                query: {
                  shopId: this.shopId,
                  tenantId: this.tenantId,
                  shopName: this.shopName
                }
              }"
            >
              <i>{{ $t('detail.Home') }}</i>
            </router-link>
          </li>
          <li :class="{ active: this.activeName === 'storeGoods' }">
            <router-link
              rel="opener"
              :to="{
                path: '/storeGoods',
                query: {
                  shopId: this.shopId,
                  inputValue: '',
                  tenantId: this.tenantId,
                  shopName: this.shopName,
                  logoTop: this.logoTop
                }
              }"
            >
              <i>{{ $t('detail.products') }}</i>
            </router-link>
          </li>
          <li>
            <Input
              search
              v-model="inputValue"
              :enter-button="$t('detail.Search')"
              :placeholder="$t('detail.placeholder')"
              style="width: 360px"
              @on-search="search"
            />
          </li>
        </ul>
        <!-- <ul v-else>
          <li>
            <Input
              search
              v-model="inputValue"
              enter-button="搜索"
              placeholder="请输入配件编码/配件名称"
              style="width: 360px; margin-left: 75%"
              @on-search="search"
            />
          </li>
        </ul> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getBasicShopMsg } from '../../../api/store'
export default {
  name: 'store-Header',
  data() {
    return {
      id: this._props.tenantId,
      storeList: {},
      inputValue: this.$route.query.inputValue || '' //搜索框内容,
    }
  },
  props: {
    activeName: String,
    shopName: String,
    logoTop: String,
    shopId: String,
    tenantId: String
  },
  created() {
    // console.log(id);
    console.log(this._props.shopId, '123')
    // console.log(this.id)
  },
  methods: {
    // 搜索传值
    search(value) {
      console.log(this.inputValue)
      console.log(value)
      this.$router.push({
        path: '/storeGoods',
        query: {
          tenantId: this.tenantId,
          shopId: this.shopId,
          inputValue: value,
          shopName: this.shopName,
          logoTop: this.logoTop
        }
      })
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
/* .store-Header /deep/ input::-webkit-input-placeholder {
    color : red;
}
:-moz-placeholder {
   color : red;
}
::-moz-placeholder {
   color : red;
}
input:-ms-input-placeholder {
   color : red;
}
input::-ms-input-placeholder {
   color : red;
} */
.store-Header {
  .main {
    width: 1200px;
    // height: 170px;
    margin: 0 auto;
    margin-top: 40px;
    .main-bg {
      // display: flex;
      height: 120px;
      // line-height: 100px;
      color: #ffffff;
      overflow: hidden;
      // background: url('../../../assets/images/main/busBanner.jpg') no-repeat
      // center center;
      // // background-size: cover;
      position: relative;
      // background: linear-gradient(
      //   81deg,
      //   rgba(212, 1, 0, 0.02) -6%,
      //   #d40100 100%
      // );
      // background-image: url('https://img.g-part.cn/test/oms/2022/6/16/1655377412393_UyTOglofg.jpg');
      opacity: 1;
      border-radius: 0px;
      img {
        width: 100%;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
      .main-logo {
        position: absolute;
        top: 23%;
        left: 2%;
        img {
          border: 2px solid #f7f7f7;
        }
      }
      .main-fullname {
        position: absolute;
        top: 41%;
        left: 16%;
        .main-span {
          font-size: 30px;
          font-weight: bold;
          letter-spacing: 6px;
          margin-right: 18px;
        }
      }
    }
    .main-search {
      height: 50px;
      line-height: 48px;
      background: #377cf1;
      color: #ffffff;
      ul {
        width: 100%;
        display: flex;
        :hover {
          background-color: #2466d5;
        }
        li > a > i {
          font-weight: 500;
          font-size: 18px;
          padding: 0 34px 0 32px;
          color: #ffffff;
        }
        li:last-child {
          margin-left: 44%;
          padding-top: 9px;
        }
        li:last-child:hover {
          background-color: #377cf1;
        }
        /deep/ input::-webkit-input-placeholder {
          color: #ffffff;
        }
        /deep/ :-moz-placeholder {
          color: #ffffff;
        }
        /deep/ ::-moz-placeholder {
          color: #ffffff;
        }
        /deep/ input:-ms-input-placeholder {
          color: #ffffff;
        }
        /deep/ input::-ms-input-placeholder {
          color: #ffffff;
        }
        /deep/ .ivu-input {
          background-color: transparent;
          border: 1px solid #ffffff;
          opacity: 0.5;
          border-radius: 0;
          color: #ffffff;
          // margin-right: ;
        }
        /* /deep/ :-moz-placeholder{
          color: #c40966 !important;
        } */
        /deep/ .ivu-input-search {
          background: #ffffff !important;
          color: #377cf1 !important;
          font-weight: 500;
          font-size: 16px;
          height: 100%;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          border: 1px solid #ffffff !important;
          // padding: 7px 7px 14px 0 ;
        }
        .active {
          background: #2466d5;
        }
      }
    }
  }
}
</style>
